import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, memo, useEffect, useCallback } from 'react';
import { TouchableOpacity, Animated, Text, View, StyleSheet, Dimensions } from 'react-native';
import styles from './PicketStyles';
import { getDynamicSelectorView, getContainerView } from '../../utils';
import { BLACK, BLACK_700, LILAC_300, WHITE } from '@airtel/air-design-system';
export var Item = React.memo(_ref => {
  var color = _ref.color,
    title = _ref.title,
    index = _ref.index,
    pressEvent = _ref.pressEvent;
  return _jsx(TouchableOpacity, Object.assign({
    onPress: () => {
      pressEvent && pressEvent(index);
    },
    style: [styles.itemWrapper, {
      height: 40
    }],
    testID: "item-" + index
  }, {
    children: _jsx(Text, Object.assign({
      style: [styles.itemText, {
        color: color
      }]
    }, {
      children: title
    }))
  }));
});
export var List = memo(React.forwardRef((_ref2, ref) => {
  var color = _ref2.color,
    showText = _ref2.showText,
    style = _ref2.style,
    onScroll = _ref2.onScroll,
    onItemIndexChange = _ref2.onItemIndexChange,
    pressEvent = _ref2.pressEvent,
    data = _ref2.data;
  var renderItem_ = _ref3 => {
    var item = _ref3.item,
      index = _ref3.index;
    return _jsx(Item, Object.assign({}, item, {
      color: color,
      index: index,
      pressEvent: pressEvent
    }));
  };
  return _jsx(Animated.FlatList, {
    ref: ref,
    data: data,
    style: style,
    keyExtractor: item => "" + item.id,
    bounces: false,
    scrollEnabled: !showText,
    scrollEventThrottle: 16,
    onScroll: onScroll,
    decelerationRate: "fast",
    snapToInterval: 40,
    showsVerticalScrollIndicator: false,
    renderToHardwareTextureAndroid: true,
    contentContainerStyle: getContainerView(),
    renderItem: renderItem_,
    onMomentumScrollEnd: ev => {
      var newIndex = Math.round(ev.nativeEvent.contentOffset.y / 40);
      if (onItemIndexChange) {
        onItemIndexChange(newIndex);
      }
    }
  });
}));
var _Dimensions$get = Dimensions.get('window'),
  width = _Dimensions$get.width;
export var Picker = _ref4 => {
  var data = _ref4.data,
    getSelectedValue = _ref4.getSelectedValue,
    selectedIndex = _ref4.selectedIndex,
    isCustomTime = _ref4.isCustomTime;
  var _React$useState = React.useState(-1),
    index = _React$useState[0],
    setIndex = _React$useState[1];
  var listRef = useRef(null);
  var refIndex = useRef(0);
  var selectorRef = useRef(null);
  var scrollY = useRef(new Animated.Value(0)).current;
  var onScroll = Animated.event([{
    nativeEvent: {
      contentOffset: {
        y: scrollY
      }
    }
  }], {
    useNativeDriver: false
  });
  var _onItemIndexChange = useCallback(setIndex, []);
  var scrollValue = useRef(40);
  useEffect(() => {
    scrollY.addListener(v => {
      scrollValue.current = v.value;
      var newIndex = Math.round((v === null || v === void 0 ? void 0 : v.value) / 40);
      if (selectedIndex !== newIndex) {
        getSelectedValue(newIndex);
        _onItemIndexChange(newIndex);
      }
      if (selectorRef === null || selectorRef === void 0 ? void 0 : selectorRef.current) {
        selectorRef.current.scrollToOffset({
          offset: v.value + 40 * 2,
          animated: false
        });
      }
    });
    if (index === -1) {
      setTimeout(() => {
        if (selectorRef === null || selectorRef === void 0 ? void 0 : selectorRef.current) {
          selectorRef.current.scrollToOffset({
            offset: 40 * 2,
            animated: false
          });
          getSelectedValue(0);
          _onItemIndexChange(0);
        }
      }, 0);
    }
  });
  return _jsxs(View, Object.assign({
    style: [styles.container, {
      backgroundColor: isCustomTime ? LILAC_300 : WHITE
    }]
  }, {
    children: [_jsx(List, {
      ref: listRef,
      color: BLACK_700,
      data: data,
      style: StyleSheet.absoluteFillObject,
      onScroll: onScroll,
      pressEvent: pressIndex => {
        try {
          _onItemIndexChange(pressIndex);
          getSelectedValue(pressIndex);
          var h = 40;
          var height = 0;
          height = h * Math.abs(index - pressIndex);
          if ((refIndex === null || refIndex === void 0 ? void 0 : refIndex.current) === 0) {
            height = height - 40;
            refIndex.current = 1;
          }
          if (listRef === null || listRef === void 0 ? void 0 : listRef.current) {
            listRef.current.scrollToOffset({
              offset: index > pressIndex ? scrollValue.current - height : scrollValue.current + height,
              animated: true
            });
          }
        } catch (error) {}
      },
      onItemIndexChange: value => {
        getSelectedValue(value);
        _onItemIndexChange(value);
      }
    }), _jsx(List, {
      ref: selectorRef,
      color: BLACK,
      data: data,
      showText: true,
      style: [styles.selectorView, getDynamicSelectorView(isCustomTime, width)]
    })]
  }));
};